// Example class
let _this = (module.exports = {
  // Set the dom elements
  dom: {
    body: document.querySelector("body"),
  },

  // Set variables
  vars: {
    flag: false,
  },

  hamburger: function () {
    const hamburger = document.querySelector(".hamburger");
    const nav = document.querySelector("nav.mobile");
    const body = document.querySelector("body");
    const menu = document.querySelectorAll(".menu-item");

    const socialIcons = document.querySelectorAll(".social-media-icons");

    if (!hamburger) return;
    if (window.innerWidth <= 991) {
      hamburger.addEventListener("click", () => {
        nav.classList.toggle("menu-open");
        hamburger.classList.toggle("menu-open");
        body.classList.toggle("menu-open");
      });

      menu.forEach((item) => {
        item.addEventListener("click", () => {
          nav.classList.remove("menu-open");
          body.classList.remove("menu-open");
          hamburger.classList.remove("menu-open");
        });
      });

      socialIcons.forEach((icon) => {
        icon.addEventListener("click", () => {
          nav.classList.remove("menu-open");
          body.classList.remove("menu-open");
          hamburger.classList.remove("menu-open");
        });
      });
    }
  },

  /**
   * Init functions
   */
  init: function () {
    this.hamburger();
  },
});
